<template>
  <!-- 实时监控 -->
  <div style="height: 100%">
    <!-- 暂无数据 -->
    <div class="noDataAvailable indexJust" style="height: 90%" v-if="cameraList && !cameraList[0] && !realTimeMonitoring">
      <noData />
    </div>
    <!-- 加载 -->
    <div class="noDataAvailable indexJust" style="height: 90%" v-if="realTimeMonitoring">
      <loadingModule />
    </div>
    <div
      v-if="cameraList && cameraList[0] && !realTimeMonitoring"
      style="display: flex; justify-content: space-around; flex-wrap: wrap; height: 100%"
    >
      <div v-for="(item, index) in cameraList" @click="playDetail(item, index)" :class="isFullScreen ? 'videoAll' : 'video'" :key="index">
        <div style="width: 100%; height: 100%; position: relative">
          <div style="width: 100%; height: 100%" v-html="item.html"></div>
          <div
            v-if="item"
            style="
              position: absolute;
              left: 0;
              top: 0;
              background: #000000;
              opacity: 0.7;
              width: 98%;
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              padding-left: 2%;
              display: flex;
              color: white;
            "
          >
            <div style="width: 70%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
              {{ item.farmName || item.deviceName }}
            </div>
            <div style="width: 30%; text-align: right; padding-right: 10px">{{ item.deviceAddress }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="videoFlex" v-if="videoLoading">
      <div class="videoFlex-box">
        <div class="videoFlex-cloes" @click="videoCloes"></div>
        <div class="videoFlex-title">{{ videoInfo.farmName || videoInfo.deviceName }}</div>
        <div class="videoFlex-all">
          <easyplayerVideo :camera="videoInfo" v-if="videoInfo.videoSrc"></easyplayerVideo>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryFarmDeviceData } from '@/api/zzry';
import { getDeviceLiveAddress } from '@/api/device';

import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import 'videojs-contrib-hls';
import 'video.js/dist/video-js.min.css';
import lang_zhcn from 'video.js/dist/lang/zh-CN.json';
videojs.addLanguage('zh-CN', lang_zhcn);

import loadingModule from '@/views/businessModule/loading1.vue';
import noData from '@/views/businessModule/noData.vue';
import easyplayerVideo from '@/components/easyplayerVideo.vue';

export default {
  name: 'projectTop',
  created() {
    let info = JSON.parse(localStorage.getItem('info'));
    let userInfo_ZHXM = JSON.parse(localStorage.getItem('userInfo_ZHXM'));
    let applicationType = localStorage.getItem('applicationType');
    this.realTimeMonitoring = true;
    const _params = {
      areaId: info.authProvincesCityAreas
    };
    if (userInfo_ZHXM && applicationType == 2) {
      _params.applicationId = userInfo_ZHXM.applicationId;
      _params.deptId = userInfo_ZHXM.deptId;
    }
    queryFarmDeviceData(_params)
      .then(res => {
        this.realTimeMonitoring = false;
        this.cameraList = res.data.data;
        if (this.cameraList.length > 0) {
          this.cameraList.forEach(item => {
            if (item.imgUrl) {
              item.html =
                '<video class="video video-js vjs-big-play-centered  vjs-default-skin" style="object-fit: cover; width: 100%;height: 100%;" id=' +
                `myVideo${item.id}` +
                ' poster=' +
                item.imgUrl +
                ' muted ></video>';
            } else {
              item.html =
                '<video class="video video-js vjs-big-play-centered  vjs-default-skin" style="object-fit: cover; width: 100%;height: 100%;" id=' +
                `myVideo${item.id}` +
                ' poster=' +
                '../assets/images/img2.png' +
                ' muted ></video>';
            }
            item.play_status = false;
          });
        }
        for (var i = 0; this.cameraList.length < 4; i++) {
          this.cameraList.push('');
        }
      })
      .catch(() => {
        this.realTimeMonitoring = false;
      });
  },
  mounted() {},
  components: {
    loadingModule,
    noData,
    easyplayerVideo
  },
  props: {
    speed: {
      default: 1,
      type: Number
    }
  },
  computed: {},
  data() {
    return {
      videoLoading: false,
      videoInfo: null,
      farmInfo: null,
      cameraList: [],
      videoIndex: '',
      isFullScreen: false,
      src: '',
      videoOptions: {
        muted: false, // 设置了它为true，才可实现自动播放,同时视频也被静音 （Chrome66及以上版本，禁止音视频的自动播放）
        autoplay: true, // 设置自动播放
        controls: true,
        controlBar: { playToggle: false },
        language: 'zh-CN',
        liveui: true,
        notSupportedMessage: '视频地址失效',
        hls: {
          withCredentials: true
        }
      },
      realTimeMonitoring: false
    };
  },
  methods: {
    playDetail(item) {
      if (!item.play_status) {
        this.videoLoading = true;
        this.videoInfo = item;
        this.$set(item, 'videoSrc', item.imgUrl);
        item.type = true;
        item.width = '100%'; // 必填摄像头宽度
        item.height = '100%'; // 必填摄像头高度
      }
    },
    videoCloes() {
      this.videoLoading = false;
    }
  },
  beforeDestroy() {
    this.cameraList.forEach(res => {
      if (res.player) {
        res.player.dispose();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.videoFlex {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(21, 20, 20, 0.9);
  z-index: 555555;
  &-box {
    position: relative;
    width: 72%;
    height: 90%;
    background: rgba(31, 43, 55, 0.9);
    left: 14%;
    top: 5%;
    padding: 0 20px 20px 20px;
  }
  &-cloes {
    width: 40px;
    height: 40px;
    background: url('../../../static/large/exit.png');
    background-size: 100% 100%;
    position: absolute;
    right: 0;
  }
  &-title {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  &-all {
    width: 100%;
    height: calc(100% - 50px);
  }
}
.noDataAvailable {
  width: 100%;
  font-size: 14px;
  color: white;
  height: calc(100% - 45px);
}
.video {
  width: 48%;
  height: 50%;
  margin-top: 2px;
  position: relative;
  &-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.videoAll {
  width: 48%;
  height: 122px;
  margin-top: 4px;
  position: relative;
  &-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 26px;
  height: 26px;
  margin-left: -14px;
}
</style>
<style scoped>
/deep/ .video-js .vjs-big-play-button {
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/businessModule/projectRightTop-yulin.vue